export const COMMENT_ITEM_BUTTONS_CONSTS = {
  dontKnow: 'Не знаю'
}
